
import Vue from 'vue';
import VueRouter from "vue-router";
import {brandRouter} from "@/components/brand/router";
import {goodsImport} from "@/components/goods/router";
import {login} from "@/components/login/router";
import {users_and_roles} from '@/components/users/router';
import {information} from '@/components/information/router';
import {translations} from '@/components/translations/router';
import {sites} from '@/components/sites/router';
import {alert} from '@/components/alert/router';
import {analytics} from '@/components/analytics/router';
import {order} from '@/components/order/router';
import {settings} from '@/components/settings/router';
import {suppliers} from '@/components/suppliers/router';
import {competitors} from '@/components/competitors/router';
import {ai} from "@/components/ai/router";

let routerList = [];

routerList = routerList.concat(brandRouter);
routerList = routerList.concat(goodsImport);
routerList = routerList.concat(login);
routerList = routerList.concat(users_and_roles);
routerList = routerList.concat(information);
routerList = routerList.concat(translations);
routerList = routerList.concat(sites);
routerList = routerList.concat(alert);
routerList = routerList.concat(analytics);
routerList = routerList.concat(order);
routerList = routerList.concat(settings);
routerList = routerList.concat(suppliers);
routerList = routerList.concat(competitors);
routerList = routerList.concat(ai);

Vue.use(VueRouter);
export const router = new VueRouter({
    routes: routerList
});